// extracted by mini-css-extract-plugin
export default {"container":"d2-z"};